/**
*
* StepBar
*
*/

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { generateTempFieldId } from 'utils/idUtils';
import AddFieldButton from './AddFieldButton';
import DeleteStep from './DeleteStep';

class StepBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shouldShowDelete: false,
    };
  }

  onMouseEnter = () => {
    if (this.props.step > 1) {
      this.setState({ shouldShowDelete: true });
    }
  };

  onMouseLeave = () => {
    if (this.props.step > 1) {
      this.setState({ shouldShowDelete: false });
    }
  };

  onAddField = () => {
    const id = generateTempFieldId();
    const { index, screens, step } = this.props;
    const keys = screens.length;
    if (step === keys) {
      this.props.addField(id);
      setTimeout(() => {
        this.props.scrollToBottom();
      }, 10);
    } else {
      this.props.addField(id, (index + 1));
    }
  };

  containsField = () => {
    const { stepId, fieldOrder } = this.props;
    const indexOfStep = fieldOrder.indexOf(stepId);
    const nextIndex = (indexOfStep + 1);
    if (fieldOrder[nextIndex] && !fieldOrder[nextIndex].match(/(screen-)/g)) {
      return true;
    }
    return false;
  };

  render() {
    let addField = null;
    let deleteStep = null;
    const { onClickDelete, step, stepId } = this.props;
    if (this.state.shouldShowDelete) {
      deleteStep = <DeleteStep onDelete={onClickDelete} step={stepId} />;
    }

    if (!this.containsField()) {
      addField = <AddFieldButton onAddField={this.onAddField} step={step} containerClassNames="mt-0 mb-4 mx-3" />;
    }

    return (
      <div
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        className="row"
      >
        <div
          id={stepId}
          className="col-12 border-top border-dark text-white p-0 my-2"
          style={{
            lineHeight: '1.65',
          }}
        >
          <span
            className="bg-dark px-3 py-1 rounded-bottom"
          >
            STEP {step}

          </span>
          {deleteStep}
        </div>
        {addField}
      </div>
    );
  }
}

StepBar.propTypes = {
  addField: PropTypes.func.isRequired,
  fieldOrder: PropTypes.array.isRequired,
  index: PropTypes.number.isRequired,
  onClickDelete: PropTypes.func.isRequired,
  screens: PropTypes.array.isRequired,
  scrollToBottom: PropTypes.func.isRequired,
  step: PropTypes.number.isRequired,
  stepId: PropTypes.string.isRequired,
};

export default StepBar;
